import FormField from "../form-field";
import Select from "../components/select";

export default class SelectField extends FormField {
    constructor(props) {
        super(props);
    }

    _afterInit() {
        this.select = new Select({
            $root: this.$input,
            subscriptions: [
                {
                    event: 'valueChange',
                    callback: this._handleValueChange.bind(this)
                }
            ]
        })
    }

    _handleValueChange(value) {
        this.controller.setValue(value);
        this._setStatus(this.controller.valid ? 'valid' : 'neutral');
    }

    _refresh() {
        const value = this.controller.getValue();

        if (!value) {
            this.select.setInitialState();
            return;
        }

        this.select.selectOptionByValue(value);
    }
}